import { z } from "zod";

export const APIResponseSuccessSchema = z.object({
  data: z.unknown(),
  message: z.string(),
  trace_id: z.string(),
  timestamp: z.string(),
  success: z.literal(true),
});

export const APIResponseErrorSchema = z.object({
  message: z.string(),
  error_code: z.string(),
  details: z.unknown(),
  trace_id: z.string(),
  timestamp: z.string(),
  success: z.literal(false),
});

export interface APIResponseSuccess<T> {
  data: T;
  message: string;
  trace_id: string;
  timestamp: string;
  success: true;
}

export interface APIResponseError<T> {
  message: string;
  error_code: string;
  details: T;
  trace_id: string;
  timestamp: string;
  success: false;
}
